// Procedural arcade sound effects via Web Audio API.
// No external files, zero dependencies.

let ctx = null;
let muted = true; // start muted until user interacts
let fanfareTimers = [];

function ensureCtx() {
  if (!ctx) {
    const Ctor = window.AudioContext || window.webkitAudioContext;
    if (!Ctor) return null;
    ctx = new Ctor();
  }
  if (ctx.state === "suspended") {
    ctx.resume().catch(() => {});
  }
  return ctx;
}

function tone({ freq = 440, type = "square", dur = 0.08, gain = 0.15, slide = 0 }) {
  const ac = ensureCtx();
  if (!ac || muted) return;
  const osc = ac.createOscillator();
  const g = ac.createGain();
  osc.type = type;
  osc.frequency.setValueAtTime(freq, ac.currentTime);
  if (slide) {
    osc.frequency.exponentialRampToValueAtTime(
      Math.max(40, freq + slide),
      ac.currentTime + dur,
    );
  }
  g.gain.setValueAtTime(gain, ac.currentTime);
  g.gain.exponentialRampToValueAtTime(0.0001, ac.currentTime + dur);
  osc.connect(g);
  g.connect(ac.destination);
  osc.start();
  osc.stop(ac.currentTime + dur + 0.02);
}

export const sfx = {
  flap() {
    tone({ freq: 520, type: "square", dur: 0.09, gain: 0.12, slide: 320 });
  },
  point() {
    tone({ freq: 880, type: "triangle", dur: 0.07, gain: 0.14 });
    setTimeout(
      () => tone({ freq: 1320, type: "triangle", dur: 0.09, gain: 0.14 }),
      70,
    );
  },
  crash() {
    const ac = ensureCtx();
    if (!ac || muted) return;
    // noise burst
    const bufSize = ac.sampleRate * 0.35;
    const buf = ac.createBuffer(1, bufSize, ac.sampleRate);
    const data = buf.getChannelData(0);
    for (let i = 0; i < bufSize; i++) {
      data[i] = (Math.random() * 2 - 1) * (1 - i / bufSize);
    }
    const src = ac.createBufferSource();
    src.buffer = buf;
    const g = ac.createGain();
    g.gain.setValueAtTime(0.25, ac.currentTime);
    g.gain.exponentialRampToValueAtTime(0.0001, ac.currentTime + 0.4);
    src.connect(g);
    g.connect(ac.destination);
    src.start();
    // low saw thud
    tone({ freq: 160, type: "sawtooth", dur: 0.3, gain: 0.2, slide: -120 });
  },
  start() {
    tone({ freq: 440, type: "square", dur: 0.08, gain: 0.1 });
    setTimeout(() => tone({ freq: 660, type: "square", dur: 0.08, gain: 0.1 }), 90);
    setTimeout(() => tone({ freq: 880, type: "square", dur: 0.12, gain: 0.1 }), 180);
  },
  fanfare() {
    sfx.stopFanfare();
    const notes = [523, 659, 784, 1047, 784, 1047, 1319];
    const durs = [0.1, 0.1, 0.1, 0.18, 0.08, 0.1, 0.35];
    let t = 0;
    notes.forEach((freq, i) => {
      fanfareTimers.push(
        setTimeout(() => {
          tone({ freq, type: "square", dur: durs[i], gain: 0.1 });
          tone({ freq: freq / 2, type: "triangle", dur: durs[i], gain: 0.08 });
        }, t),
      );
      t += durs[i] * 1000 * 0.9;
    });
  },
  stopFanfare() {
    fanfareTimers.forEach(clearTimeout);
    fanfareTimers = [];
  },
};

export function setMuted(v) {
  muted = !!v;
  if (!muted) ensureCtx();
}
export function isMuted() {
  return muted;
}
export function unlockAudio() {
  ensureCtx();
}
